export const serializeToIST = (timestampInMillis: any) => {
    if (!timestampInMillis) return null;
    const date = new Date(timestampInMillis);
    return date.getTime();
  };